/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputGeoJsonFeature } from './OutputGeoJsonFeature';
import {
    OutputGeoJsonFeatureFromJSON,
    OutputGeoJsonFeatureFromJSONTyped,
    OutputGeoJsonFeatureToJSON,
} from './OutputGeoJsonFeature';

/**
 * 
 * @export
 * @interface OutputGeoJson
 */
export interface OutputGeoJson {
    /**
     * 
     * @type {Array<OutputGeoJsonFeature>}
     * @memberof OutputGeoJson
     */
    features: Array<OutputGeoJsonFeature>;
    /**
     * 
     * @type {string}
     * @memberof OutputGeoJson
     */
    type: string;
}

/**
 * Check if a given object implements the OutputGeoJson interface.
 */
export function instanceOfOutputGeoJson(value: object): boolean {
    if (!('features' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function OutputGeoJsonFromJSON(json: any): OutputGeoJson {
    return OutputGeoJsonFromJSONTyped(json, false);
}

export function OutputGeoJsonFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoJson {
    if (json == null) {
        return json;
    }
    return {
        
        'features': ((json['features'] as Array<any>).map(OutputGeoJsonFeatureFromJSON)),
        'type': json['type'],
    };
}

export function OutputGeoJsonToJSON(value?: OutputGeoJson | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'features': ((value['features'] as Array<any>).map(OutputGeoJsonFeatureToJSON)),
        'type': value['type'],
    };
}

